import '../App.css';
import BrownLightIcon from './BrownLightIcon';
import GreenLightIcon from './GreenLightIcon';
import GreyLightIcon from './GreyLightIcon';
import RedLightIcon from './RedLightIcon';

const FaultLevelLightIcon = (props) => {
    const { level } = props;

    const displayLight = (currentLevel) => {
        switch (currentLevel) {
            case -1:
                return (<GreyLightIcon />);
            case 0:
                return (<GreenLightIcon />);
            case 1:
                return (<RedLightIcon />);
            case 2:
                return (<BrownLightIcon />);
        }
    };

    return (
        <>
            {displayLight(level)}
        </>
    );
};

export default FaultLevelLightIcon;